import { connect, ConnectedProps } from 'react-redux';
import { reset } from 'redux-form';

import {
  FORM_ORGANIZATION_DETAILS_NAME,
  FormOrganizationDetailsData,
} from 'dashboard/forms/FormOrganizationDetails';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { Organization } from 'dashboard/models/organization';
import { clearMessages, showMessage } from 'dashboard/redux/actions/messages';
import { setOrganization } from 'dashboard/redux/actions/organization';
import { RootState } from 'dashboard/redux/store';
import DashboardOrganizationInformationView from 'dashboard/views/DashboardOrganizationInformationView';
import { ApiModel } from 'lib/interfaces/api';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

const DashboardOrganizationInformationRoute = (props: PropsFromRedux) => {
  const updateOrganizationDetails = async (attributes: FormOrganizationDetailsData) => {
    props.clearMessages();

    try {
      const { data: organization } =
        await SessionClientDashboard.updateResourceSingleton<Organization>({
          attributes,
          type: ApiModel.Organization as const,
        });
      props.setOrganization(organization);
      props.showMessage('Organization details were updated', MessageType.Success);
    } catch (error) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      if (isPermissionsError(error)) {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        props.showMessage(permissionsErrorMessage(error), MessageType.Failure);
      } else {
        props.showMessage('Please try again', MessageType.Failure);
      }
      props.reset(FORM_ORGANIZATION_DETAILS_NAME);
    }
  };

  return (
    <DashboardOrganizationInformationView
      organization={props.organization}
      environments={props.environments}
      currentEnvironment={props.currentEnvironment}
      updateOrganizationDetails={updateOrganizationDetails}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  organization: state.organization.organization,
  environments: state.organization.environments,
  currentEnvironment: state.currentEnvironment.currentEnvironment,
});

const mapDispatchToProps = {
  setOrganization,
  showMessage,
  clearMessages,
  reset,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardOrganizationInformationRoute);
